import { render, staticRenderFns } from "./Buywh8.vue?vue&type=template&id=7b465474&scoped=true&"
import script from "./Buywh8.vue?vue&type=script&setup=true&lang=js&"
export * from "./Buywh8.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Buywh8.vue?vue&type=style&index=0&id=7b465474&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b465474",
  null
  
)

export default component.exports